import styled from 'styled-components'
import { Typography } from 'src/components'

export const TypographySection = styled(Typography)`
    line-height: 36px;
    font-family: inherit;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 46px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 45%;
        text-align: center;
    }
`
export const TypographyContent = styled(Typography)`
    line-height: 26px;
    font-family: inherit;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        text-align: center;
    }
`
